import * as moment from 'moment';

export const formatTimeCell = (
  timestamp: string | number | Date | null | undefined
): string => {

  if (!timestamp) return '';

  const timeFormat = getStoredTimeFormat();

  const timePart = timeFormat
    ? timeToMoment(timeFormat)
    : 'hh:mm A';

  return moment(Number(timestamp)).format(timePart);
};

export const getDate = (
  timestamp: string | number | Date | null | undefined
): string => {

  if (!timestamp) return '';

  const dateFormat = getStoredDateFormat();

  const datePart = backendToMomentDisplay(dateFormat);

  return moment(Number(timestamp)).format(datePart);
};

export function formatDateCell(
  timestamp: string | number | Date | null | undefined
): string {

  if (!timestamp) return '';

  const dateFormat = getStoredDateFormat();
  const timeFormat = getStoredTimeFormat();

  const datePart = backendToMomentDisplay(dateFormat);

  const timePart = timeFormat
    ? timeToMoment(timeFormat)
    : 'hh:mm A';

  const finalFormat =
    `${datePart} ${timePart}`.trim();

  return moment(Number(timestamp)).format(finalFormat);
}

export function formatDateCellInDateOnly(
  timestamp: string | number | Date | null | undefined
): string {

  if (!timestamp) return '';

  return moment(Number(timestamp)).format('DD MMM, YYYY');
}

export function toLocalDateAndtime(
  timestamp: string | number | Date
): string {

  if (!timestamp) return '';

  return moment(Number(timestamp))
    .local()
    .format('MMM DD, YYYY hh:mm A');
}


function getStoredDateFormat(): string {
  try {
    const stored = localStorage.getItem('dateFormatRecord');
    return stored ? JSON.parse(stored) : 'dd MMM, yyyy';

  } 
  catch (error) {
    console.warn('Failed to parse dateFormatRecord',error);
    return 'dd MMM, yyyy';
  }
}

function getStoredTimeFormat(): string | null {
  try {
    const stored = localStorage.getItem('timeFormatRecord');
    const parsed = stored ? JSON.parse(stored) : null;
    return parsed && parsed.trim() !== '' ? parsed : null;
  } 
  catch (error) {
    console.warn(
      'Failed to parse timeFormatRecord',
      error
    );
    return null;
  }
}


function backendToMomentDisplay( format: string ): string {

  if (!format) {
    return 'DD MMM, YYYY';
  }

  const tokenMap: Record<string, string> = {
    yyyy: 'YYYY',
    yy: 'YY',
    dd: 'DD',
    d: 'D',
    MM: 'MM',
    M: 'M',
  };

  let momentFormat = format.replace(
    /yyyy|yy|dd|d|MM|M/g,
    (match) => tokenMap[match] || match
  );

  momentFormat = momentFormat.replace(/MM|M/g,'MMM');
  momentFormat = momentFormat.replace(/(\s|-)?YYYY/,', YYYY');
  momentFormat = momentFormat.replace(/-/g, ' ');

  return momentFormat.trim();
}

function timeToMoment(format: string): string {

  if (!format) {
    return 'hh:mm A';
  }

  const tokenMap: Record<string, string> = {
    HH: 'HH',
    hh: 'hh',
    mm: 'mm',
    ss: 'ss',
    a: 'A',
  };

  return format.replace(
    /HH|hh|mm|ss|a/g,
    (match) => tokenMap[match] || match
  );
}